<template>
  <div class="home">
    <div class="banner">
      <div class="banner-container">
        <div class="download">
          <a target="_blank" href="https://apps.apple.com/app/id1623853314"><DownloadAppStore class="btn-download"></DownloadAppStore></a>
          <a target="_blank" href="https://a.app.qq.com/o/simple.jsp?pkgname=tech.xiangzi.life"><DownloadAndroid class="btn-download"></DownloadAndroid></a>
        </div>
        <div class="slogan"></div>
      </div>
    </div>
    <!-- 功能介绍 -->
    <div class="specs">
      <div class="spec-item">
        <div class="container">
          <div class="spec-demo">
            <img src="https://website.dislikeapp.com/feature-diary.png" alt="">
          </div>
          <div class="spec-text">
            <h3 class="spec-title">日记</h3>
            <div class="spec-content">
              <p>日记是最具体的生命的痕迹的记录。</p>
              <p class="signature">— 季羡林</p>
              <p>只能记录文字和照片，纯净、歇斯底里，像一本真正的日记。</p>
              <p class="signature">— 我说的</p>
            </div>
          </div>
        </div>
      </div>
      <div class="spec-item">
        <div class="container">
          <div class="spec-text">
            <h3 class="spec-title">自传</h3>
            <div class="spec-content">
              <p>以一个旁观者的角度审视自己的人生，并以此为最大的幸福。</p>
              <p>我想让这个世界记得，你曾经来过。</p>
            </div>
          </div>
          <div class="spec-demo">
            <img src="https://website.dislikeapp.com/feature-autobio.png" alt="">
          </div>
        </div>
      </div>
      <div class="spec-item">
        <div class="container">
          <div class="spec-demo">
            <img src="https://website.dislikeapp.com/feature-nine.png" alt="">
          </div>
          <div class="spec-text">
            <h3 class="spec-title">九点</h3>
            <div class="spec-content">
              <p>每晚九点钟，夜色会和素未谋面的情绪一起拉开帷幕。</p>
              <p>陌生人呀，我也为你祝福。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="spec-item">
        <div class="container">
          <div class="spec-text">
            <h3 class="spec-title">传记广场</h3>
            <div class="spec-content">
              <p>如今我们深夜饮酒，杯子碰到一起，都是梦破碎的声音。</p>
              <p>不如，我们讲一讲彼此的故事吧...</p>
            </div>
          </div>
          <div class="spec-demo">
            <img src="https://website.dislikeapp.com/feature-bios.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- 会员价格 -->
    <div class="pro" ref="pro">
      <div class="container">
        <h3 class="title">产品价格</h3>
        <div class="memberships">
          <div class="membership free">
            <h3 class="member-title">免费会员</h3>
            <div class="member-price">
              <span class="currency">￥</span>
              <span class="price-integer">0</span>
            </div>
            <div class="member-feature" v-for="item in freeFeatures" :key="item.path">
              <CheckIcon class="check-icon"></CheckIcon>
              <p>{{item}}</p>
            </div>
          </div>
          <div class="membership pro">
            <h3 class="member-title">年费高级会员</h3>
            <div class="member-price">
              <span class="currency">￥</span>
              <span class="price-integer">128</span>
              <span class="bill-period">/年</span>
            </div>
            <div class="member-feature" v-for="item in annualProFeatures" :key="item.path">
              <CheckIcon class="check-icon"></CheckIcon>
              <p>{{item}}</p>
            </div>
            <el-button type="text" v-if="!user || !user.pro || user.pro == 0" v-on:click="purchaseProduct('web_year')" class="btn btn-theme btn-purchase" data-toggle="modal" data-target="#purchase-modal">立即购买</el-button>
            <el-button type="text" v-cloak v-else-if="user.pro === 2" v-on:click="purchaseProduct('web_year')" class="btn btn-theme btn-purchase" data-toggle="modal" data-target="#purchase-modal">立即续费</el-button>
            <button v-cloak v-else class="btn btn-theme btn-disabled btn-purchase">已购买</button>
          </div>
          <div class="membership ever">
            <h3 class="member-title">捐赠终身荣誉会员</h3>
            <div class="member-price">
              <span class="currency">￥</span>
              <span class="price-integer">798</span>
              <span class="bill-period"></span>
            </div>
            <div class="member-feature" v-for="item in everProFeatures" :key="item.path">
              <CheckIcon class="check-icon"></CheckIcon>
              <p>{{item}}</p>
            </div>
            <button v-on:click="purchaseProduct('web_ever')" class="btn btn-theme btn-purchase" data-toggle="modal" data-target="#purchase-modal">捐赠</button>
          </div>
        </div>
        <div class="notes">
          <p class="notes-title">订购须知</p>
          <div class="notes-content">
            <p><span class="number">1.</span>年费高级会员需连续订购满 10 年、或会员存续期内摇篮触发后 10 张永久照片空间方可生效；</p>
            <p><span class="number">2.</span>高级会员资格在 iPhone、Android、Web 平台通用；</p>
            <p><span class="number">3.</span>如购买后会员状态未及时生效，你可以尝试退出账号后重新登录；</p>
            <p><span class="number">4.</span>考虑到服务的特殊性，会员购买后不支持退款，敬请谅解。</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 会员购买会话框 -->
    <el-dialog class="purchase-dialog-wrapper" title="高级会员" :visible.sync="showPurchaseDialog" @close="resetPurchasePopup">
      <div class="purchase-dialog">
        <el-form>
          <el-form-item>
            <label class="my-1 mr-2" for="inputGroupSelect01">类型：</label>
            <el-select v-model="selectedProduct.productId" @change="switchProduct()" class="custom-select" id="inputGroupSelect01">
              <el-option disabled value="">请选择订购类型</el-option>
              <el-option v-for="option in products" :key="option.productId" :value="option.productId" :label="option.title"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <label class="my-1 mr-2" for="inputGroupSelect02">数量：</label>
            <el-select v-model="selectedProduct.number" :disabled="selectedProduct.maxNumber == 1" class="custom-select" id="inputGroupSelect02">
              <el-option disabled value="">请选择订购数量</el-option>
              <el-option v-for="(n, i) in selectedProduct.maxNumber" :value="n" :key="i"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="total-price">
            <span class="currency">￥</span><span class="price-integer">{{ selectedProduct.price * selectedProduct.number }}</span><span class="price-decimal">.00</span>
          </el-form-item>
        </el-form>
        <div class="dialog-footer">
          <button @click="pay(0)" type="button" class="btn btn-pay btn-pay-wechat">微信支付</button>
          <button @click="pay(1)" type="button" class="btn btn-pay btn-pay-alipay">支付宝支付</button>
        </div>
        <!-- 微信支付二维码占位 -->
        <div v-cloak v-show="showWechatQRCode" class="dialog-wxpay-qrcode">
          <div class="qrcode-wrapper">
            <div id="wechat-pay-qrcode"></div>
            <div class="top-left"></div>
            <div class="top-right"></div>
            <div class="bottom-right"></div>
            <div class="bottom-left"></div>
          </div>
          <p class="qrcode-tips mr-2">微信扫码支付<span class="price-integer ml-2">{{ selectedProduct.price * selectedProduct.number }}</span><span class="price-decimal mr-2">.00</span>元</p>
        </div>
        <!-- 支付宝跳转后占位 -->
        <div v-cloak v-show="showAlipayWaiting" class="dialog-alipay-waiting">
          <div class="alipay-logo"></div>
          <p>支付宝支付中...</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from '@/api';
import QRCode from 'qrcodejs2';
import DownloadAppStore from '@/components/svgIcon/downloadAppStore.vue';
import DownloadAndroid from '@/components/svgIcon/downloadAndroid.vue';
import CheckIcon from '@/components/svgIcon/check.vue';

export default {
  components: {
    DownloadAppStore,
    DownloadAndroid,
    CheckIcon
  },
  data () {
    return {
      freeFeatures: [
        '无限制文字日记',
        '无限制文字传记',
        '多终端同步',
        '3 张永久照片空间',
      ],
      annualProFeatures: [
        '无限制文字日记',
        '无限制文字传记',
        '多终端同步',
        '10 张永久照片空间 ¹',
        '日记内添加照片',
        '摇篮服务',
        '10G 普通照片存储空间',
      ],
      everProFeatures: [
        '无限制文字日记',
        '无限制文字传记',
        '多终端同步',
        '10 张永久照片空间',
        '日记内添加照片',
        '摇篮服务',
        '10G 普通照片存储空间',
      ],
      selectedProduct: {
        productId: 'web_year',
        title: '年订购会员',
        number: 1,
        maxNumber: 10,
        price: 128.00
      },
      products: [{
        productId: 'web_year',
        title: '年订购会员',
        period: '年',
        number: 1,
        maxNumber: 10,
        originalPrice: 128.00,
        price: 128.00
      }, {
        productId: 'web_ever',
        title: '终身荣誉会员',
        period: '',
        number: 1,
        maxNumber: 1,
        originalPrice: 798.00,
        price: 798.00
      }],
      showPurchaseDialog: false,
      showWechatQRCode: false,
      showAlipayWaiting: false,
      isWechat: /MicroMessenger/.test(navigator.userAgent),
      isBackdropFilterSupported: true // 兼容不支持 backdrop-filter 属性的浏览器（如：微信）
    }
  },
  mounted () {
    this.scrollPage()
  },
  watch: {
    $route (to, from) {
      this.scrollPage()
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUserLoginInfo;
    },
  },
  created: function () {
    this.isBackdropFilterSupported = this.supportsCSS('backdrop-filter', 'blur()')
  },
  methods: {
    async getUserInfo () {
      const uid = localStorage.getItem('$$uid');
      const token = localStorage.getItem('$$token');
      // 未登录状态
      if (!uid || !token) {
        // this.$router.replace('/login');
        return;
      }
      // 已登录状态，更新用户信息
      try {
        const { data } = await api.user.getUserInfo(`/users/${uid}/`, {
          Authorization: token
        });
        this.$store.commit('updateUserLoginInfo', Object.assign({}, data, {
          ticket: token
        }));
      } catch (e) {
        console.error(e)
        // this.$router.replace('/login');
      }
    },
    scrollPage: function () {
      if (this.$route.path === '/price') {
        window.scrollTo({
          top: this.$refs.pro.offsetTop,
          behavior: 'smooth'
        })
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    purchaseProduct: function (productId) {
      var temp = this.products.find(elem => elem.productId === productId)
      this.selectedProduct.productId = temp.productId
      this.selectedProduct.title = temp.title
      this.selectedProduct.price = temp.price
      this.selectedProduct.maxNumber = temp.maxNumber
      this.selectedProduct.number = 1
      this.showPurchaseDialog = true
    },
    signIn: function () {
      this.$router.push('/login')
      // var callbackurl = window.location.href;
      // if (callbackurl.indexOf('code=') > 0) {
      //   callbackurl = this.removeUrlParam('code')
      // }
      // if (this.isWechat) {
      //   // 微信环境
      //   window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf96d5b925e17d660&redirect_uri=' + encodeURIComponent(callbackurl) + '&response_type=code&scope=snsapi_userinfo#wechat_redirect'
      // } else {
      //   // H5 环境
      //   window.location.href = 'https://open.weixin.qq.com/connect/qrconnect?appid=wxd29dd4a46421945b&scope=snsapi_login&redirect_uri=' + encodeURIComponent(callbackurl)
      // }
    },
    switchProduct: function () {
      var temp = this.products.find(elem => elem.productId === this.selectedProduct.productId)
      this.selectedProduct.title = temp.title
      this.selectedProduct.price = temp.price
      this.selectedProduct.maxNumber = temp.maxNumber
      this.selectedProduct.number = 1
    },
    pay: function (payMethod) {
      // 三种支付类型：0-微信网页支付，1-支付宝支付，2-微信环境支付
      var self = this
      if (!localStorage.getItem('$$token')) {
      // if (!self.user) {
        self.signIn()
        return
      }

      var newTab = null;
      // 如果是微信支付，且在微信应用内打开
      if (self.isWechat && payMethod === 0) {
        payMethod = 2;
      } else if (payMethod === 1) {
        // 解决支付宝支付新窗口打开的问题
        newTab = window.open();
      }

      this.$fetch({
        url: `/users/${self.user.uid}/membership/pay`,
        method: 'post',
        data: {
          productId: self.selectedProduct.productId,
          count: self.selectedProduct.number,
          method: payMethod
        }
      }).then(res => {
        if (payMethod === 0) {
          // 微信支付：网页端
          // eslint-disable-next-line no-unused-vars
          var qrcode = new QRCode('wechat-pay-qrcode', {
            text: res.data.redirectUrl,
            width: 180,
            height: 180,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          })
          self.showWechatQRCode = true
        } else if (payMethod === 1) {
          // 支付宝支付
          const div = document.createElement('div');
          div.innerHTML = res.data.redirectUrl; // html code
          newTab.document.body.appendChild(div);
          newTab.document.forms[0].submit();
          self.showAlipayWaiting = true
        }
        // else if (payMethod === 2) {
        //   // 微信支付：微信应用内
        //   self.onBridgeReady(res.data);
        // }
        // 5 秒后开始轮询支付结果
        if (payMethod !== 2) {
          setTimeout(function () {
            self.checkPurchaseStatus(res.data.orderId)
          }, 5000)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    checkPurchaseStatus: function (orderID) {
      var self = this;
      var checkTimes = 0; // 已轮询次数
      // 轮询购买结果状态
      var intervalID = setInterval(function () {
        self.$fetch({
          url: `/users/${self.user.uid}/order/${orderID}`,
          method: 'get',
        })
          .then(function (response) {
            if (response.data.status === 1 || response.data.status === '1') {
            // 支付成功
              clearInterval(intervalID)
              self.resetPurchasePopup()
              self.getUserInfo()
              self.$message({
                type: 'success',
                offset: 70,
                message: `支付成功！`
              })
              self.releaseBalloon()
            } else if (checkTimes > 90) {
            // 支付超时
              clearInterval(intervalID)
              self.resetPurchasePopup()
            }
          })
          .catch(function (error) {
            console.log(error)
          });

        checkTimes++
      }, 2000);
    },
    resetPurchasePopup: function () {
      this.showPurchaseDialog = false;
      this.showWechatQRCode = false
      this.showAlipayWaiting = false
    },
    // 检测是否支持特定 CSS 属性
    supportsCSS: function (attribute, value) {
      if (window.CSS && window.CSS.supports) {
        if (typeof value === 'undefined') return window.CSS.supports(attribute)
        return window.CSS.supports(attribute, value)
      }

      const elem = document.createElement('div')
      if (attribute in elem.style) {
        elem.style[attribute] = value
        return elem.style[attribute] === value
      }
      return false
    },
    // 支付成功彩蛋
    releaseBalloon: function () {
      var intervalTimer = null;
      var itemsPerSecond = 8; // 每秒出现个数
      // 关键帧样式
      const body = document.getElementsByTagName('body')[0];
      const keyframes = `@keyframes anim-item {
          0% {
              top: 100vh;
          }
          100% {
              top: -100px;
          }
      }`;
      const style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = keyframes;
      document.getElementsByTagName('head')[0].appendChild(style)
      // 开始动画
      intervalTimer = setInterval(() => {
        // 创建元素
        const xOffset = Math.random() * (document.body.offsetWidth - 50); // 随机位置（距屏幕左侧距离）
        const e = document.createElement('div');
        e.textContent = '🎈'
        e.style.width = '50px';
        e.style.height = '50px';
        e.style.fontSize = `${2 + Math.random()}em`;
        e.style.backgroundSize = '50px';
        e.style.position = 'fixed';
        e.style.bottom = '-100px';
        e.style.left = `${xOffset}px`;
        e.style.animation = `anim-item ${3}s 1 ease-in`;
        e.style.zIndex = 1000;
        e.className = 'anim-item';
        body.appendChild(e);
      }, 1000 / itemsPerSecond);
      // 自动停止创建新元素
      setTimeout(function () {
        clearInterval(intervalTimer)

        // 移除已创建元素
        setTimeout(() => {
          document.querySelectorAll('.anim-item').forEach(function (elem) {
            elem.remove()
          })
        }, 5000)
      }, 5000)
    }
  }
}
</script>
<style lang="less" scoped>
@import url('~@/assets/styles/variable.less');

.home {
  .banner {
    height: 600px;
    font-size: 18px;
    background: #f8f8f8 url(https://website.dislikeapp.com/journal-banner.jpg) no-repeat top center;
    background-size: 100% auto;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    .banner-container {
      width: 900px;
      height: 600px;
      margin: 0 auto;
      .download {
        padding: 320px 0 40px 7px;
        .btn-download {
          margin-right: 10px;
          cursor: pointer;
          opacity: 0.8;
          transition: opacity 0.2s ease-out;
          &:hover {
            opacity: 1;
          }
        }
      }
      .slogan {
        width: 900px;
        height: 120px;
        background: url(https://website.dislikeapp.com/journal-slogan.png) no-repeat 0 0;
        background-size: 50%;
      }
    }
  }
  .specs .spec-item {
    height: 600px;
    .container {
      width: 900px;
      height: 600px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }
    &:nth-child(odd) {
      background-color: #fff;
    }
    &:nth-child(even) {
      background-color: #f8f8f8;
    }
    .spec-demo {
      width: 360px;
      height: 600px;
      display: flex;
      align-items: flex-end;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      img {
        width: 360px;
      }
    }
    .spec-text {
      padding-top: 100px;
      width: 500px;
      line-height: 1.8;
      letter-spacing: 2px;
      text-align: justify;
    }
    .spec-title {
      font-size: 28px;
      font-weight: 700
    }
    .spec-content p {
      margin-top: 40px;
      font-size: 21px;
      &.signature {
        margin-top: 0;
        text-align: right;
      }
    }
  }
  .pro {
    .container {
      width: 900px;
      padding: 50px 0;
      margin: 0 auto;
    }
    .title {
      font-size: 32px;
      font-weight: 700;
      line-height: 1.8;
      letter-spacing: 2px;
      text-align: center;
      margin-bottom: 50px;
    }
    .memberships {
      display: flex;
      justify-content: space-around;
    }
    .membership {
      .member-title {
        margin: 0 0 10px;
        font-size: 21px;
      }
      .member-price {
        margin: 0 0 20px;
        color: #fc2504;
        .price-integer {
          font-size: 32px;
          font-weight: bold;
        }
        .price-decimal {
          margin: 0 5px 0 0;
        }
      }
      .member-feature {
        margin: 10px 0;
        display: flex;
        align-items: center;
        .check-icon {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
      }
      .btn-purchase {
        width: 120px;
        height: 40px;
        padding: 0;
        font-size: 18px;
        margin-top: 30px;
      }
    }
    .notes {
      margin: 80px 0 0;
      font-size: 14px;
      color: #666;
      line-height: 1.8;
      .notes-title {
        font-size: 16px;
        font-weight: bold;
      }
      .number {
        display: inline-block;
        width: 16px;
        margin: 0 5px 0 0;
        text-align: center;
      }
    }
  }
}
// 模态窗口样式
.modal-open .main {
  filter: blur(3px);
  .modal-backdrop.show {
    opacity: 0.1;
  }
}
.purchase-dialog {
  border-radius: 15px;
  .custom-select {
    border-radius: 3px;
    width: auto;
  }
  .total-price {
    color: #fc2504;
  }
  .price-integer {
    font-size: 32px;
    font-weight: bold;
  }
  .price-decimal {
    margin: 0 5px 0 0;
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    .btn-pay {
      width: 210px;
      height: 50px;
      color: #fff;
      font-size: 16px;
      padding: 0 0 0 20px;
      &.btn-pay-wechat {
        background: #2ba044 url('https://website.dislikeapp.com/icon-wepay.png') no-repeat 10px center;
        background-size: 30px;
      }
      &.btn-pay-alipay {
        background: #00A1E9 url('https://website.dislikeapp.com/icon-alipay.png') no-repeat 10px center;
        background-size: 30px;
      }
    }
  }
  // 支付
  .dialog-wxpay-qrcode,
  .dialog-alipay-waiting {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: #fff;
    text-align: center;
    border-radius: 10px;
  }
  .dialog-wxpay-qrcode .qrcode-wrapper,
  .dialog-alipay-waiting .alipay-logo {
    display: inline-block;
    position: relative;
    margin: 50px auto 20px;
    padding: 10px;
    width: 200px;
    height: 200px;
  }
  .dialog-alipay-waiting .alipay-logo {
    background: transparent url('https://website.dislikeapp.com/open-alipay-color.svg') no-repeat center center;
    background-size: 200px;
  }
  .dialog-wxpay-qrcode .qrcode-wrapper .top-left,
  .dialog-wxpay-qrcode .qrcode-wrapper .top-right,
  .dialog-wxpay-qrcode .qrcode-wrapper .bottom-right,
  .dialog-wxpay-qrcode .qrcode-wrapper .bottom-left {
    position: absolute;
    width: 30px;
    height: 30px;
  }
  .dialog-wxpay-qrcode .qrcode-wrapper {
    .top-left {
      top: 0;
      left: 0;
      border-top: 1px solid #ccc;
      border-left: 1px solid #ccc;
    }
    .top-right {
      top: 0;
      right: 0;
      border-top: 1px solid #ccc;
      border-right: 1px solid #ccc;
    }
    .bottom-right {
      bottom: 0;
      right: 0;
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
    }
    .bottom-left {
      bottom: 0;
      left: 0;
      border-bottom: 1px solid #ccc;
      border-left: 1px solid #ccc;
    }
  }
  .dialog-wxpay-qrcode .qrcode-tips,
  .dialog-alipay-waiting p {
    font-size: 16px;
  }
  .dialog-wxpay-qrcode .price-integer,
  .dialog-wxpay-qrcode .price-decimal {
    color: #ff6060;
  }
}
</style>
<style lang="less">
.purchase-dialog-wrapper .el-dialog {
  width: 500px;
  border-radius: 10px;
}
</style>
